import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import FileDownload from '../../components/FileDownload';
import FileUpload from '../../components/FileUpload';
import FileDelete from '../../components/FileDelete';

export default function FilesList({ filesPackage, onFilesChange, visitID }) {
    const handleFileUpload = (uploadedPackage) => {
        onFilesChange(uploadedPackage);
    };

    const handleFileDelete = (fileId) => {
        onFilesChange({
            ...filesPackage,
            files: filesPackage.files.filter((file) => file.id !== fileId),
        });
    };

    return (
        <Box>
            <Typography variant="h6" sx={{ mt: 2 }}>
                Resultados y archivos
                <FileUpload
                    onFileUpload={handleFileUpload}
                    parentType="Visit"
                    packageID={filesPackage?.id}
                    parentID={visitID}
                />
            </Typography>
            <Paper elevation={1} sx={{ p: 1, display: 'flex', gap: 1 }}>
                {filesPackage?.files?.map((file, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0, mb: 1 }}>
                        <FileDownload fileName={file.name} fileId={file.id} />
                        <FileDelete
                            fileId={file.id}
                            onDelete={() => handleFileDelete(file.id)}
                        />
                    </Box>
                ))}
            </Paper>
        </Box>
    );
}
